import { Sorting } from "@app/models/paginateList";

export class BarrierListFilter {
    denominazione!: string;
    indirizzo!: string;
    utilizzo!: number;
    comune!: string;
    provincia!: string;
    codiceSbarramento!: string;
    tutti!: boolean;

    constructor(init?: Partial<BarrierListFilter>) {
        Object.assign(this, init);
    }
}

export enum LabelMap {
    denominazione = "name",
    indirizzo = "address",
    utilizzo = "purpose",
    comune = "municipality",
    provincia = "province",
    tutti = "all-versions",
}

export const sortList: Sorting[] = [
    { campo: "aggiornamento", verso: "DESC" },
    { campo: "aggiornamento", verso: "ASC" },
    { campo: "denominazione", verso: "ASC" },
    { campo: "denominazione", verso: "DESC" },
];
